'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _upperFirst2 = require('lodash/upperFirst');

var _upperFirst3 = _interopRequireDefault(_upperFirst2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ProjectTypeTooltip = require('components/ProjectTypeTooltip/ProjectTypeTooltip');

var _ProjectTypeTooltip2 = _interopRequireDefault(_ProjectTypeTooltip);

var _ProjectIrefTooltip = require('components/ProjectIrefTooltip/ProjectIrefTooltip');

var _ProjectIrefTooltip2 = _interopRequireDefault(_ProjectIrefTooltip);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ProjectStatus = require('components/Project/ProjectStatus/ProjectStatus');

var _ProjectStatus2 = _interopRequireDefault(_ProjectStatus);

var _MoreButton = require('components/MoreButton/MoreButton');

var _MoreButton2 = _interopRequireDefault(_MoreButton);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _utils = require('helpers/utils');

var _ProjectItemPopover = require('components/Projects/ProjectItemPopover/ProjectItemPopover');

var _ProjectItemPopover2 = _interopRequireDefault(_ProjectItemPopover);

var _projects = require('helpers/projects');

var _ProjectItemActions = require('components/Projects/ProjectItemActions/ProjectItemActions');

var _ProjectItemActions2 = _interopRequireDefault(_ProjectItemActions);

var _loadReducer = require('redux/loadReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectsListItem.scss');

var useOldReports = true; //TODO: remove?


var ProjectsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ProjectsListItem, _PureComponent);

  function ProjectsListItem() {
    (0, _classCallCheck3.default)(this, ProjectsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectsListItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectsListItem, [{
    key: 'onClickEdit',
    value: function onClickEdit() {
      this.editProject();
    }
  }, {
    key: 'onClickPopup',
    value: function onClickPopup() {
      return _toastr2.default.info(this.context.t('You don\'t have permissions to edit this project'));
    }
  }, {
    key: 'onClickCreateProj',
    value: function onClickCreateProj() {
      return this.createSubproject();
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          project = _props.project,
          onClick = _props.onClick;

      if (onClick) {
        return onClick(project);
      }

      var actionOnClick = project.actionOnClick;

      if (actionOnClick) {
        var method = 'onClick' + (0, _upperFirst3.default)(actionOnClick);
        return this[method] ? this[method]() : false;
      }
    }
  }, {
    key: 'projectReport',
    value: function projectReport(e) {
      (0, _utils.stopEvent)(e);
      var project = this.props.project;
      var push = this.context.push;

      if (useOldReports) {
        push('/projects/' + project.projectContentType + '/' + project.id + '/report');
      } else {
        push('/statistics/project/' + project.id);
      }
    }
  }, {
    key: 'editProject',
    value: function editProject(e) {
      (0, _utils.stopEvent)(e);
      var push = this.context.push;
      var _props2 = this.props,
          onEdit = _props2.onEdit,
          project = _props2.project;

      onEdit();
      push('/projects/' + project.projectContentType + '/' + project.id + '/materials');
    }
  }, {
    key: 'deleteProject',
    value: function deleteProject(e) {
      (0, _utils.stopEvent)(e);
      var _props3 = this.props,
          onDelete = _props3.onDelete,
          project = _props3.project;
      var t = this.context.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return onDelete(project);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this project?'), toastrConfirmOptions);
    }
  }, {
    key: 'createSubproject',
    value: function createSubproject(e) {
      (0, _utils.stopEvent)(e);
      var _props4 = this.props,
          onCreateSubproject = _props4.onCreateSubproject,
          project = _props4.project;
      var push = this.context.push;

      onCreateSubproject();
      push('/projects/' + project.projectContentType + '/' + project.id + '/create');
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          className = _props5.className,
          project = _props5.project,
          showTypeColumn = _props5.showTypeColumn,
          showActionsColumn = _props5.showActionsColumn,
          deleteLoaders = _props5.deleteLoaders,
          userPermissions = _props5.userPermissions;

      var _getProjectPermission = (0, _projects.getProjectPermissions)({ project: project, userPermissions: userPermissions }),
          canDelete = _getProjectPermission.canDelete,
          canEdit = _getProjectPermission.canEdit,
          canGetReport = _getProjectPermission.canGetReport,
          canCreateSubproject = _getProjectPermission.canCreateSubproject;

      var isDeleting = deleteLoaders[(0, _loadReducer.getLoaderKey)([project.id])];

      return _react2.default.createElement(
        _ListItem2.default,
        { fullWidth: true, key: project.id, className: (0, _bind2.default)('cursor-pointer', className), onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: 'pos-rel' },
          project.watermarkTracks && _react2.default.createElement('div', { className: styles.isWatermark }),
          project.id
        ),
        _react2.default.createElement(
          'div',
          null,
          project.fullTitle
        ),
        showTypeColumn && _react2.default.createElement(
          'div',
          { className: styles.typeCell },
          _react2.default.createElement(_ProjectTypeTooltip2.default, { projectType: project.projectContentType })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.irefCell },
          _react2.default.createElement(_ProjectIrefTooltip2.default, { iRef: project.iRef })
        ),
        _react2.default.createElement(
          'div',
          null,
          project.owName
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ProjectStatus2.default, { status: project.status })
        ),
        showActionsColumn && _react2.default.createElement(
          'div',
          { className: styles.actionsCell },
          _react2.default.createElement(_ProjectItemActions2.default, {
            className: (0, _bind2.default)(styles.actions, 'hidden-md hidden-sm hidden-xs'),
            project: project,
            onReport: this.projectReport,
            onCreateSubproject: this.createSubproject,
            onDelete: this.deleteProject,
            onEdit: this.editProject,
            userPermissions: userPermissions
          }),
          _react2.default.createElement(
            'div',
            { className: (0, _bind2.default)('moreCell hidden-lg', styles.actionsMenu) },
            _react2.default.createElement(_MoreButton2.default, {
              onClick: this.togglePopover,
              loading: isDeleting,
              containerClass: styles.moreContainer,
              buttonClass: styles.moreIcon
            })
          )
        ),
        showActionsColumn && _react2.default.createElement(_ProjectItemPopover2.default, {
          id: 'projectItemPopover_' + project.id,
          onEdit: this.editProject,
          onDelete: this.deleteProject,
          onCreateSubproject: this.createSubproject,
          onReport: this.projectReport,
          onInit: this.bindPopover,
          hideCreateSubproject: !canCreateSubproject,
          hideEdit: !canEdit,
          hideReport: !canGetReport,
          hideDelete: !canDelete
        })
      );
    }
  }]);
  return ProjectsListItem;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  deleteLoaders: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onCreateSubproject: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  project: _propTypes2.default.object,
  showActionsColumn: _propTypes2.default.bool,
  showTypeColumn: _propTypes2.default.bool,
  userPermissions: _propTypes2.default.object
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  deleteLoaders: {},
  onCreateSubproject: _noop3.default,
  onDelete: _noop3.default,
  onEdit: _noop3.default,
  project: {},
  userPermissions: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClickEdit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickEdit'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClickPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickPopup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClickCreateProj', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClickCreateProj'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'projectReport', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'projectReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'editProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'editProject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteProject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createSubproject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createSubproject'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype)), _class);
exports.default = ProjectsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectsListItem/ProjectsListItem.js
// module id = 2066
// module chunks = 1